import { NotificationsAction }from './actions';
import { NotificationsItem } from '../../../containers/NotificationsContainer/NotificationsContainer';

import {
    UNREAD_NOTIFICATIONS_REQUEST_START,
    UNREAD_NOTIFICATIONS_REQUEST_FAIL,
    UNREAD_NOTIFICATIONS_REQUEST_SUCCESS,
    GET_NOTIFICATIONS_REQUEST_START,
    GET_NOTIFICATIONS_REQUEST_FAIL,
    GET_NOTIFICATIONS_REQUEST_SUCCESS,
    READ_NOTIFICATIONS_REQUEST_START,
    READ_NOTIFICATIONS_REQUEST_FAIL,
    READ_NOTIFICATIONS_REQUEST_SUCCESS,
} from './types';
import { LoadingEvent } from '../../../core/types/GeneralTypes';

type NotificationsState = {
    unreadCount: number,
    loadingState: LoadingEvent,
    allNotifications: Array<NotificationsItem>,
    getAllNotificationsLoadingState: string,
    readNotificationsLoadingState: string,
};

const INITIAL_STATE: NotificationsState = {
    unreadCount: 0,
    loadingState: 'UNINITIALIZED',
    allNotifications: [],
    getAllNotificationsLoadingState: 'UNINITIALIZED',
    readNotificationsLoadingState: 'UNINITIALIZED',
};

export const reducer = (
    state: NotificationsState = INITIAL_STATE,
    action: NotificationsAction
): NotificationsState => {
    switch(action.type) {
        case UNREAD_NOTIFICATIONS_REQUEST_START:
            return {
                ...state,
                loadingState: 'LOADING'
            };

        case UNREAD_NOTIFICATIONS_REQUEST_SUCCESS:
            return {
                ...state,
                loadingState: 'LOADED',
                unreadCount: action.payload
            };

        case UNREAD_NOTIFICATIONS_REQUEST_FAIL:
            return {
                ...state,
                loadingState: 'ERROR'
            };

        case GET_NOTIFICATIONS_REQUEST_START:
            return {
                ...state,
                getAllNotificationsLoadingState: 'LOADING'
            };

        case GET_NOTIFICATIONS_REQUEST_SUCCESS:
            return {
                ...state,
                getAllNotificationsLoadingState: 'LOADED',
                allNotifications: action.payload
            };

        case GET_NOTIFICATIONS_REQUEST_FAIL:
            return {
                ...state,
                getAllNotificationsLoadingState: 'ERROR',
            };

        case READ_NOTIFICATIONS_REQUEST_START:
            return {
                ...state,
                readNotificationsLoadingState: 'LOADING',
            };

        case READ_NOTIFICATIONS_REQUEST_SUCCESS:
            return {
                ...state,
                readNotificationsLoadingState: 'LOADED',
            };

        case READ_NOTIFICATIONS_REQUEST_FAIL:
            return {
                ...state,
                readNotificationsLoadingState: 'ERROR',
            };

        default:
            return state;
    }
};